window.addEventListener("load", function () { console.log("Zafiro");
});


window.addEventListener('scroll', function(event) {
 var template = document.getElementById("template").value;

  if(template == "template-index"){
   
     if (window.scrollY > 0) {
         let header_desktop = document.querySelector('#header_desktop');
          header_desktop.classList.remove("hide-menu-horizontal-home");
         let header_mobile = document.querySelector('#header_mobile');
          header_mobile.classList.remove("show-menu-hamburguesa-home");
          document.getElementById("shopify-section-sections--18640129163513__announcement-bar").style.position =  "fixed";
           const only_logo = document.getElementsByClassName("logo-only");
            only_logo[0].style = "display:block;";
           const only_logo2 = document.getElementsByClassName("header__logo");
             only_logo[0].style = "justify-content: center;";
     } else {
       let header_desktop = document.querySelector('#header_desktop');
          header_desktop.classList.add("hide-menu-horizontal-home");
       let header_mobile = document.querySelector('#header_mobile');
          header_mobile.classList.add("show-menu-hamburguesa-home");
        document.getElementById("shopify-section-sections--18640129163513__announcement-bar").style.position =  "relative";
       const only_logo = document.getElementsByClassName("logo-only");
            only_logo[0].style = "display:none; ";
     }
  }
});